// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"421":"dd93c289","581":"951d963b","676":"78471ed1","878":"ed55d602"}[chunkId] + ".chunk.js";
};